function AmazonService(ApiService) {
  'ngInject';
  const service = {};

  service.saveFile = function(amazonfileForm, orgId, callbackFunc) {
    ApiService.saveFile(`/organizations/${orgId}/amazon_inventories`, amazonfileForm, callbackFunc);
  };

  service.getamazonJournals = function(orgId, url, pageNumber,size, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.getJournal = function(orgId, journalId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/amazon_journals/${journalId}.json`, callbackFunc);
  };

  service.updateJournal = function(orgId, journalId, data, callbackFunc) {
    ApiService.patch(`/organizations/${orgId}/amazon_journals/${journalId}.json`, data, callbackFunc);
  };

  service.getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  service.reportExists = function(orgId,date,callbackFunc){
    ApiService.get(`/organizations/${orgId}/amazon_journals/validate_date.json?date=${date}`, callbackFunc);
  };

  service.tryNow = function(orgId, date, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/amazon_journals/try_now.json?date=${date}`, callbackFunc);
  };

  service.repostJournal = function(orgId, journalId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/amazon_journals/${journalId}/repost_to_xero.json`, callbackFunc);
  };

  return service;
}

export default{
  name: 'AmazonService',
  fn: AmazonService
}
